module.exports = __webpack_public_path__ + "img/0Q3A6952_P_L_WoodMatted_MockedUp.f77790e4.jpg";